<template>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div id="errorNotification" class="col-md-12">
          <base-alert v-if="errorMessage != null" type="danger">
            <span class="alert-inner--text"> {{errorMessage}}</span>
            <button type="button" class="close" aria-label="Close" @click="removeMessage('error')">
              <span aria-hidden="true">&times;</span>
            </button>
          </base-alert>
          <base-alert v-if="successMessage != null" type="success">
            <span class="alert-inner--text"> {{successMessage}}</span>
            <button type="button" class="close" aria-label="Close" @click="removeMessage('success')">
              <span aria-hidden="true">&times;</span>
            </button>
          </base-alert>
        </div>
        <div class="col-md-3">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{_.startCase(currentProfile)}}
          </h3>
        </div>
        <div v-if="accountId != null" class="col-md-9 text-right">  
            <base-button class="float-right ml-1" type="primary" size="sm" @click.prevent="showDrawer(0)">
              Account Licensing Settings
            </base-button>
        </div>

      </div>

    </div>

    <a-drawer title="" :width="480" placement="right" @close="onClose" :visible="drawerVisible">
      <div v-if="profileAction == 'customize_list'">
        <h6 class="heading-small text-muted mb-4">Customize Fields</h6>
        <ul v-if="availableFields.length > 0" class="list-group list-group-flush" style="width: 100%">
          <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7">
            <div class="row">
              <div class="col-md-6">
                AVAILABLE FIELDS
              </div>
              <div class="col-md-6">
                <a-checkbox @change="onCheckAllField" :checked="fields.length == (availableFields.length + 4)"
                  class="float-right" />
              </div>
            </div>
          </li>

          <li class="list-group-item" style="font-size: 14px" v-for="field in availableFields" v-bind:key="field">
            <div class="row">
              <div class="col-md-6">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{field}}
              </div>
              <div class="col-md-6">
                <a-checkbox @change="onCheckField(field)" :checked="fields.includes(field)" class="float-right" />
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div v-if="profileAction == 'export_list'">
        <h6 class="heading-small text-muted mb-4">Export Options</h6>
        <div>
          <base-radio name="0" class="mb-3" v-model="filterStatus" value="O">
            Export All
          </base-radio>
          <base-radio name="1" class="mb-3" v-model="filterStatus" value="1">
            Export Current Page
          </base-radio>
          <base-radio name="2" class="mb-3" v-model="filterStatus" value="2">
            Export Selected
          </base-radio>
          <base-radio name="3" class="mb-3" v-model="filterStatus" value="3">
            Export Filtered
          </base-radio>
        </div>
      </div>
      <div
        v-if="profileAction == 'export_list'"
        style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
        <button type="button" class="btn btn-primary float-right" @click.prevent="download">Export</button>
      </div>

      <div v-if="profileAction == 'view_license'">
        <!-- <h6 class="heading-small text-muted mb-4">VIEW LICENSE</h6> -->
        <license-form @refreshPage="refreshPage" :accountId="accountId" :key="componentKey"></license-form>
      </div>
    </a-drawer>

    <a-drawer title="" :width="480" placement="right" @close="onClose" :visible="visible">
      <account-form @refreshPage="refreshPage" :key="componentKey" :accountId="accountId" @updateAvailableLicense="updateAvailableLicense"></account-form>      
    </a-drawer>

    <div class="table-responsive">
      <vuetable v-if="accountId != null" ref="vuetable" :api-url="apiURL" :http-options="httpOptions" :fields="fields" :sort-order="sortOrder"
        :show-sort-icons="true" :per-page="10" :css="css.table" pagination-path="" data-path="data" no-data-template="Empty"
        @vuetable:checkbox-toggled-all="log" @vuetable:checkbox-toggled="log" @vuetable:load-error="onLoadError" 
        @vuetable:pagination-data="onPaginationData">

        <template slot="actions" slot-scope="props">
          <center>
            <div class="table-button-container">
              <button class="btn btn-default btn-sm" @click.prevent="viewLicense(props.rowData.id)">Manage License</button>&nbsp;&nbsp;
            </div>
          </center>
        </template>
      </vuetable>
      <div v-else class="col-md-12">
        <center>
          <h5 class="navbar-heading text-muted">Please select an account for viewing.</h5>
        </center>
        <br/>
      </div>
    </div>

    <div class="card-footer d-flex justify-content-end" :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="pagination ui basic segment grid">
        <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage" :css="css.pagination">
        </vuetable-pagination>
      </div>
    </div>

  </div>
</template>

<script>
  import TerminalForm from '../POS Profiles/TerminalForm2.vue';
  import LicenseForm from '../POS Profiles/License/LicenseForm2.vue';
  import AccountForm from '../POS Profiles/License/AccountForm.vue';
  import axios from "axios";
  import {
    mapState,
    mapActions
  } from 'vuex'

  import Vuetable from "vuetable-2/src/components/Vuetable";
  import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
  import secureStorage from '../../controllers/secureStorage';
  import HTTPRequest from '../../controllers/httpRequest.js';

  let ADMIN_KEY = "123456"

  var component_x;

  export default {
    name: 'licenses-table',
    props: {
      type: {
        type: String
      },
      title: String
    },
    components: {
      Vuetable,
      VuetablePagination,
      TerminalForm,
      LicenseForm, 
      AccountForm
    },
    computed: {
      ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'profileId', 'parameters']),
    },
    data() {
      return {
        accountId: null,
        numberOfLicense: 0,
        filterStatus: "",
        profileAction: "",
        checkedFields: [],
        checkedItems: [],
        availableFields: [],
        errorMessage: null,
        successMessage: null,
        componentKey: 0,
        drawerVisible: false,
        visible: false,
        apiURL: "",
        fields: ["id", "name", "expiry_date", "license_version", '__slot:actions'],
        sortOrder: [{
          field: "name",
          direction: "asc"
        }],
        httpOptions: {
          headers: {
            Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
          }
        },
        css: {
          table: {
            tableClass: 'table table-sm table-striped table-bordered table-hovered',
            loadingClass: 'loading'
          },
          pagination: {
            infoClass: 'pull-right',
            wrapperClass: 'vuetable-pagination pull-right',
            activeClass: 'btn-primary btn-sm',
            disabledClass: 'disabled',
            pageClass: 'btn btn-border',
            linkClass: 'btn btn-border',
            icons: {
              first: '',
              prev: '',
              next: '',
              last: '',
            },
          }
        }
      }
    },
    watch: {
      currentApiURL: function () {
        this.$refs.vuetable.resetData()
        this.apiURL = this.currentApiURL 
      },
      parameters: function () {     
        this.apiURL = this.currentApiURL
        this.apiURL = this.apiURL + this.parameters + "&mode=admin&account_id=" + this.accountId
        this.$refs.vuetable.selectedTo = []		
        this.checkedItems = []
      }
    },
    methods: {
      ...mapActions(['updateProfileId']),
      refreshPage() {
        this.onClose()
        this.$refs.vuetable.refresh()
        this.successMessage = "Successful Operation"
        this.errorMessage = null
      },
      showDrawer(id) {
        this.componentKey++
        this.updateProfileId(id)
        this.visible = true
      },
      async showActionDrawer(action) {
        if (action == "customize_list") {
          var response = await HTTPRequest.getRequest(
            this.endPoint + this.currentProfile + "/get_viewable_fields",
            null
          );
          
          let unsortedFields = response["fields"];
          let sortedFields = this.checkedFields.slice();

          unsortedFields.forEach(fieldName => {
            if (!this.checkedFields.includes(fieldName))
              sortedFields.push(fieldName)
          });

          this.availableFields = sortedFields;

        }
        this.profileAction = action;
        this.drawerVisible = true;
      },
      onClose() {
        this.drawerVisible = false
        this.visible = false
        this.componentKey++
      },
      updateAvailableLicense(){
        this.$emit("updateAvailableLicense")
      },
      log() {
        this.checkedItems = this.$refs.vuetable.selectedTo
      },
      onCheckField(fieldName) {
        if (this.fields.includes(fieldName)) {
          var indexValue = this.fields.indexOf(fieldName)
          if (indexValue > -1) this.checkedFields.splice(indexValue, 1)
          var indexValue2 = this.checkedFields.indexOf(fieldName)
          if (indexValue2 > -1) this.fields.splice(indexValue, 1)
        } else {
          this.fields.pop()
          this.fields.push(fieldName)
          this.fields.push("__slot:actions")
          this.checkedFields.push(fieldName)
        }
        this.$refs.vuetable.normalizeFields()
      },
      onCheckAllField() {},
      async massupdate(field_name, value) {
        var field_update = {}
        field_update[field_name] = value
        var payload = {
          ids: this.checkedItems,
          field_update: field_update
        }
        var response = await HTTPRequest.postRequest(this.endPoint + this.currentProfile + "/mass_update", null,
          payload)
        if (response["message"] == "Ok") {
          this.successMessage = "Update successful!"
          this.$refs.vuetable.refresh()
          this.checkedItems = []
          this.$refs.vuetable.selectedTo = []
        } else {
          this.successMessage = "Update failed!"
        }
      },
      onPaginationData(paginationData) {
        this.$refs.pagination.setPaginationData(paginationData);
      },
      async onLoadError(error) {
        // request for new token or reauthenticate
        if (error.response.status == 401) {
          var auth_response = await HTTPRequest.authenticate(component_x.endPoint)
          if (auth_response["status"] == "Ok") {
            this.$router.go();
          } else {
            alert("Cannot get access token. Please login again.")
            this.$router.push("/")
          }
        }
      },
      onChangePage(page) {
        this.$refs.vuetable.changePage(page);
      },
      deleteRow(id) {
        axios({
            method: 'delete',
            url: this.endPoint + this.currentProfile + '/' + id,
            headers: {
              Authorization: 'Bearer ' + secureStorage.getItem("accessToken"),
              "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
            },
          })
          .then(function () {
            component_x.successMessage = "Successfully deleted record"
            component_x.$refs.vuetable.refresh()
          })
          .catch(function () {
            alert("Invalid Credentials")
          });
      },
      download() {
        var payload = {}
        var additional_parameters = ""
        var baseUrl = this.currentApiURL + "/download?file_type=csv"
        if (this.filterStatus == "0") {
          // All
          payload["type"] = "all"
        } else if (this.filterStatus == "1") {
          // Current Page
          payload["type"] = "current_page"
          additional_parameters = this.parameters
          additional_parameters = additional_parameters + "&page=" + this.$refs.vuetable.currentPage + "&per_page=" +
            this.$refs.vuetable.perPage
        } else if (this.filterStatus == "2") {
          // Selected
          payload["type"] = "selected"
          payload["ids"] = this.checkedItems
        } else {
          // Filtered
          payload["type"] = "filtered"
          additional_parameters = this.parameters
        }

        var exportFields = this.fields
        var cbIndex = this.fields.indexOf("__checkbox");
        if (cbIndex > -1) exportFields.splice(cbIndex, 1)
        var actionIndex = this.fields.indexOf("__slot:actions");
        if (actionIndex > -1) exportFields.splice(actionIndex, 1)

        payload["fields"] = exportFields
        additional_parameters = additional_parameters.replace('?', '&');

        axios({
          url: baseUrl + additional_parameters,
          method: 'POST',
          responseType: 'blob', // important
          headers: {
            Authorization: 'Bearer ' + secureStorage.getItem("accessToken"),
            "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress")
          },
          data: payload,
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'file.csv');
          document.body.appendChild(link);
          link.click();
          this.onClose();
          this.filterStatus = null
          this.successMessage = "Download successful"
        });
      },
      displayMessage(message) {
        if (message["error"] != undefined) {
          this.onClose()
          this.errorMessage = message["error"]
          this.successMessage = null
        }
      },
      removeMessage(type) {
        if (type == 'error')
          this.errorMessage = null
        else
          this.successMessage = null
      },
      viewLicense( id ){
            var password = prompt('Please input passcode',' ');
            if(password == ADMIN_KEY){
              this.updateProfileId(id)
              this.drawerVisible = true
              this.profileAction = "view_license"
              this.componentKey++
            } else {
                alert("Invalid passcode")
            }
        }
    },
    mounted: function () {
      component_x = this;
      this.accountId = this.$attrs.accountId
      this.apiURL = this.currentApiURL + "?mode=admin&account_id=" + this.accountId
    }
  }
</script>

<style>
</style>